import React from 'react'
import styled from 'styled-components'
import { Button } from '../../Common/Button'

export const Footer = () => {
	return(
		<StyledFooter>

		<strong>Step 3.</strong>
		<p>Click on the button to go to your Gmail settings, and make sure you're logged in using your primary email address (@goldenstate.is, @moontide.agency, etc...)</p>
		<small>(If you didn't get directly to settings, then click the gear icon in the top right and select "Settings" from the dropdown)</small>
		<Button onClick={() => window.open("https://mail.google.com/mail/u/1/#settings/general", "_blank")}>
		Gmail Settings
		</Button>

		<strong>Step 4.</strong>
		<p>Click "Save Changes" at the bottom of the Gmail settings page</p>

		</StyledFooter>
		)
}

const StyledFooter = styled.div`
margin-bottom: 4rem;
text-align: left;
max-width: 800px;
p {
	margin-top: 5px;
	margin-bottom: 0;
	line-height: 25px;
}
strong {
	margin-top: 50px;
	display: block;
}
small {
	font-weight: 500;
	margin-top: 5px;
	margin-bottom: 1em;
	display: block;
}
`
